module.exports = __webpack_public_path__ + "static/media/teacher-chalkboard.39f64734.png";